"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Queue = void 0;
var Queue = /** @class */ (function () {
    function Queue(size, _items) {
        if (_items === void 0) { _items = []; }
        this.size = size;
        this._items = _items;
    }
    Queue.prototype.enqueueMulti = function (elements) {
        var _this = this;
        elements.forEach(function (element) {
            _this.enqueue(element);
        });
    };
    Queue.prototype.enqueue = function (element) {
        if (this._items.length > this.size) {
            this.dequeue();
        }
        this._items.push(element);
    };
    Queue.prototype.dequeue = function () {
        if (this.isEmpty()) {
            console.warn('Queue is empty');
            return;
        }
        return this._items.shift();
    };
    Queue.prototype.front = function () {
        if (this.isEmpty()) {
            console.warn('No elements in Queue');
            return;
        }
        return this._items[0];
    };
    Object.defineProperty(Queue.prototype, "items", {
        get: function () {
            return this._items;
        },
        enumerable: false,
        configurable: true
    });
    Queue.prototype.isEmpty = function () {
        return this._items.length === 0;
    };
    Queue.prototype.unload = function () {
        this._items = [];
    };
    Object.defineProperty(Queue.prototype, "length", {
        get: function () {
            return this._items.length;
        },
        enumerable: false,
        configurable: true
    });
    return Queue;
}());
exports.Queue = Queue;
